import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/** What each fire Statement of Compliance detail means to an owner. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['fire-compliance'],
  declarations: [
    identity('address', 'Address', 'agency_reference'),
    administrative(
      'link',
      'group',
      'data_as_of',
      'data_loaded_at',
      ':id',
      ':created_at',
      ':updated_at',
    ),
    means('date', 'the statement date', ['date']),
    means('detail', 'the compliance document', ['documentUrl'], {
      matters: 'means a new or replaced document',
    }),
  ],
});
